import { render, staticRenderFns } from "./ChildReport.vue?vue&type=template&id=3db30dfa&scoped=true&"
import script from "./ChildReport.vue?vue&type=script&lang=js&"
export * from "./ChildReport.vue?vue&type=script&lang=js&"
import style0 from "./ChildReport.vue?vue&type=style&index=0&id=3db30dfa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db30dfa",
  null
  
)

export default component.exports